export type HiveTheme = {
	primaryColor: string;
	secondaryColor: string;
	buttonPrimaryHover: string;
	buttonPrimaryText: string;
	barcodeDark: string;
};

export type Photo = Blob | File;

export type ErrorDetails = {
	title: string;
	description: string;
}

export enum PhotoStep {
	front_side = 'front_side',
	back_side = 'back_side',
	selfie = 'selfie',
}

export enum PhotoType {
	identity_document = 'identity_document',
	face = 'face',
}

export enum SupportLanguage {
	en = 'en'
}

export enum MountMode {
	modal = 'modal',
	inline = 'inline'
}

export enum MountType {
	fallback = 'fallback',
	verification = 'verification',
	crossDeviceVerification = 'cross_device_verification',
	invalid_device = 'invalid_device',
	desktop_custom_error = 'desktop_custom_error',
	mobile_custom_error = 'mobile_custom_error',
}

export type EventSubscriber = {
	event: string;
	callback: Function;
}
export type EmitEventPayload = {
	event: string;
	payload: any,
}
export type LocalizationOptions = {
	languageSelector: boolean | null;
	language: string | null;
	languagesWhitelist: string[] | null,
	languageBaseUrl: string | null;
	supportedLanguages: { [key: string]: string }
}
export type VerifyOptions = {
	mode: MountMode;
	theme: Partial<HiveTheme>;
	languageSelector: boolean;
	language: 'es' | 'en' | 'fr' | 'de';
}
export type IntentParams = {
	options: Partial<VerifyOptions & {
		intent: {
			logo: string;
		}
	}>;
	applicationKey: string;
};
export type BaseParams = {
	options: Partial<VerifyOptions>;
	applicationKey: string;
};
export type CrossDeviceParams = {
	room: string;
	params?: { q?: string };
};
export type VerifyParams = BaseParams | CrossDeviceParams | IntentParams;
export type MountParams = {
	mode: MountMode;
	type: MountType;
	container: HTMLElement;
	error?: ErrorDetails;
}
export type SessionConfig = {
	id: string,
	company: string,
	hive_link: boolean;
	urls: {
		tos_url: string,
		support_url: string,
		handoff_url: string,
		hive_link_url: string,
	}
}
export type SessionTokenPayload = {
	room: string;
	session_id: string;
	iat: number;
	exp: number;
}

export interface IPInfoResult {
	city: string;
	country: string;
	ip: string;
	loc: string;
	org: string;
	postal: string;
	region: string;
	timezone: string;
}

export function isIntentParams(params: VerifyParams): params is IntentParams {
	return 'applicationKey' in params && 'intent' in params.options;
}
